export const TEST_TYPE_OPTIONS = {
  price_test: "Price Test",
  shipping_test: "Shipping Test",
  content_test: "Content Test",
  offer_test: "Offer Test",
  checkout_test: "Checkout Test",
  personalizations: "Personalization",
  no_test_type: "No Test Type",
} as const;

export type TestTypeKey = keyof typeof TEST_TYPE_OPTIONS;
